import React from "react";
import PrintableAddForm from "@/components/PrintableAddForm";

const ROWS = [
  [
    { label: "Item name", flex: 3 },
    { label: "Type (roll / unit / bag / …)", flex: 2 },
  ],
  [
    { label: "Category", flex: 2 },
    { label: "Material", flex: 2 },
    { label: "Colour", flex: 1 },
  ],
  [
    { label: "Department", flex: 2 },
    { label: "Location on shelf", flex: 3 },
  ],
  [
    { label: "Unit (sheet / kg / each …)", flex: 2 },
    { label: "Pack size", flex: 1 },
    { label: "Sub-unit (if any)", flex: 2 },
  ],
  [
    { label: "Supplier", flex: 3 },
    { label: "Unit cost (approx)", flex: 2 },
  ],
];

const StocktakeAddItemPrint = () => (
  <PrintableAddForm
    pageTitle="Add inventory item"
    toolbarHint="Hand this out to staff during stocktake. Any item they find that isn't already in the app — one form per new item, then give the page back to the manager."
    eyebrow="Podlab · Stocktake"
    scope="Stocktake · new items"
    formTitle="Add-inventory sheet"
    rows={ROWS}
    starField={{ label: "QTY on hand (physical count)" }}
    noteLabel="Notes / anything else the manager should know"
    testid="add-item-print-page"
  />
);

export default StocktakeAddItemPrint;
